import React from "react";
import { Link } from "react-router-dom";
import { WHATSAPP_PHONE } from "../config";
import { trackEvent } from "../lib/analytics";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container footer-shell">
        <div className="footer-brand">
          <p className="footer-kicker">A1 Pro</p>
          <h5 className="footer-title">Cursos premium y paquetes con descuento real</h5>
          <p className="footer-copy">
            Somos la seccion especial de a1cursosmaster para promociones, combos y
            negociacion directa de paquetes.
          </p>
          <a
            className="footer-whatsapp"
            href={`https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}`}
            onClick={() => trackEvent("whatsapp_click", { source: "footer_contact" })}
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa fa-whatsapp me-2" aria-hidden="true"></i>
            +51 915 151 528
          </a>
        </div>

        <div className="footer-links-block">
          <h6>Accesos rapidos</h6>
          <div className="footer-links-list">
            <Link className="footer-link" to="/about#faq">
              Preguntas frecuentes
            </Link>
            <Link className="footer-link" to="/como-comprar">
              Como comprar
            </Link>
            <Link className="footer-link" to="/privacy">
              Politicas de privacidad
            </Link>
          </div>
        </div>

        <div className="footer-links-block">
          <h6>Red principal</h6>
          <div className="footer-links-list">
            <a
              className="footer-link"
              href="https://a1cursosmaster.com"
              target="_blank"
              rel="noreferrer"
            >
              a1cursosmaster.com
            </a>
            <span className="footer-domain">pro.a1cursosmaster.com</span>
          </div>
        </div>
      </div>
      <div className="container footer-bottom">
        <span>© {new Date().getFullYear()} A1 Pro</span>
        <span>Atencion y cierre de compra por WhatsApp</span>
      </div>
    </footer>
  );
};

export default Footer;
